import { render } from "./WarehouseItemStatusButton.vue?vue&type=template&id=6dc771ce&scoped=true"
import script from "./WarehouseItemStatusButton.vue?vue&type=script&lang=js"
export * from "./WarehouseItemStatusButton.vue?vue&type=script&lang=js"

import "./WarehouseItemStatusButton.vue?vue&type=style&index=0&id=6dc771ce&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc771ce"]])

export default __exports__